module.exports = __webpack_public_path__ + "7cccca0bde818122054a7155ed93f7e0.png";